import React, { useEffect, useState } from "react";
import MainEnlaces from "./MainEnlaces";
import PokemonCard from "./PokemonCard";

const MainPokemon = () => {
  const [data, setData] = useState([]);
  const [nextp, setNextp] = useState("");
  const [prevp, setPrevp] = useState("");
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [url, setUrl] = useState("https://pokeapi.co/api/v2/pokemon");

  useEffect(() => {
    async function pokemon() {
      setLoader(true)
      try {
        let res = await fetch(url);
        if (!res.ok) {
          let err = new Error("ocurrió un error");
          err.status = res.status;
          err.statusText = res.statusText;
          throw err;
        }
        let json = await res.json();
        if (json.next) {
          setNextp(json.next);
        } else {
          setNextp("");
        }
        if (json.previous) {
          setPrevp(json.previous);
        } else {
          setPrevp("");
        }
        json.results.map(async (el) => {
          let res = await fetch(el.url);
          let json = await res.json();
          let objeto = {
            nombre: json.name,
            foto: json.sprites.front_default,
            id: json.id,
            alto: json.height,
          };
          setData([...data, data.push(objeto)]);
          setLoader(false)
          setError(false);
        });
      } catch (error) {
        console.log(error);
        setError(true);
        setData([]);
        setLoader(false)
      }
    }
    pokemon();
  }, [url]);
  let styleP = {
    fontSize:"1.5rem",
    color:"white",
    textAlign:"center"
  }
  return (
    <>
      <h1
        style={{
          textTransform: "uppercase",
          textAlign: "center",
          color: "white",
          fontFamily: "sans-serif",
        }}
      >
        lista de Pokemon
      </h1>
      <nav>
        <MainEnlaces
          prevp={prevp}
          nextp={nextp}
          setData={setData}
          setUrl={setUrl}
        />
      </nav>
      {error && <p style={styleP}>ocurrió un error al solicitar los datos</p>}
      {loader && <p style={styleP}>Cargando...</p>}
      <div className="card-contenedor">
        {data &&
          data
            .slice(0, 19)
            .map((el, index) => <PokemonCard key={index} el={el} />)
        }
      </div>
    </>
  );
};

export default MainPokemon;
